'use client';

import { useEffect, useState } from 'react';
import { LogIn, FileText } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ERROR_MESSAGES = {
    token_expired:
        'Your verification link has expired. Please contact the support team.',
    invalid_token:
        'The verification link is invalid. Please contact the support team.',
    verification_failed:
        'Email verification failed. Please contact the support team.',
    token:
        'Verification token is missing. Please contact the support team.',
};

export default function HomePage() {
    const [verificationError, setVerificationError] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const error = params.get('error');

        if (!error) {
            return;
        }

        // Store error in React state first
        setVerificationError(error);

        // Remove ?error=... from browser URL
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname
        );
    }, []);

    useEffect(() => {
        if (!verificationError) {
            return;
        }

        const message = ERROR_MESSAGES[verificationError];

        if (!message) {
            setVerificationError(null);
            return;
        }

        // Wait until ToastContainer is mounted
        const timer = setTimeout(() => {
            toast.error(message, {
                position: 'top-right',
                autoClose: 5000,
                closeOnClick: true,
                pauseOnHover: true,
            });

            setVerificationError(null);
        }, 100);

        return () => clearTimeout(timer);
    }, [verificationError]);

    return (
        <div
            className="h-screen bg-cover bg-center flex flex-col justify-center items-center text-white text-center px-6"
            style={{ backgroundImage: "url('/images/bg.jpg')" }}
        >
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
            />

            <img
                src="/images/logo.png"
                alt="logo"
                className="max-w-[150px] mb-[20px]"
            />

            <p className="text-sm mb-5 max-w-[1000px] leading-[2em]">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. It has survived not only five centuries, but also the
                leap into electronic typesetting.
            </p>

            <div className="flex gap-3">
                <a href="/login">
                    <div className="flex gap-1 items-center bg-[#49bef3] hover:bg-blue-700 text-white py-[6px] px-6 rounded-[50px] text-sm border-2 border-blue-500">
                        <LogIn size={20} />
                        <button>Login</button>
                    </div>
                </a>

                <a href="/register">
                    <div className="flex gap-1 items-center bg-[#49bef3] hover:bg-blue-700 text-white py-[6px] px-6 rounded-[50px] text-sm border-2 border-blue-500">
                        <FileText size={20} />
                        <button>Register</button>
                    </div>
                </a>
            </div>
        </div>
    );
}